import { decode } from '@finn-no/safe-props';
import { DataProps } from 'types/uiTypes';

type Dataset = {
    props: string;
};

const useDataProps = () => {
    const app = document.getElementById('tjt-podlet-create-offer-button');
    const dataset = app?.dataset as Dataset;
    return decode(dataset.props) as DataProps;
};

export default useDataProps;
